export default "__VITE_ASSET__92e8a556__"